<template>
<div>
    <v-dialog v-model="dialog" max-width="590">
        <v-card class="pa-4">
            <v-icon class="close-btn" @click="dialog = false">mdi-close</v-icon>
            <v-card-title class="headline primary--text pt-8" style="font-size: 18px !important;">Purchase Confirmation</v-card-title>
            <v-card-title class="pt-0">{{checkout.name}} Plan</v-card-title>
            <v-card-text style="background: #efeeee;padding: 26px;border-radius: 20px;margin-bottom: 24px;display: flex;align-items: center;">
                <v-row align="center">
                    <v-col cols="12" md='6'>
                        <v-icon color="primary">mdi-cloud</v-icon> Credit : {{checkout.credit}}
                    </v-col>
                    <v-col cols="12" md="6" class="text-right">
                        <span class="display-1 pa-0">${{checkout.amount_usd}}</span> <span style="font-size: 20px;">/ month</span>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions class="pa-4" style="border-top: 1px solid #ddd">
                <v-spacer></v-spacer>
                <v-btn class="pl-4" :loading="loading" @click="Checkout(checkout)" color="primary" rounded small>
                    Checkout Now <v-icon right>mdi-arrow-right</v-icon>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-container>
        <v-row justify="center" align="end">
            <v-col cols="12" sm="6" md="3" v-for="(item, i) in priceSort(plans)" :key="i">
                <div v-if="item.name == 'Skilled'" style="background: #4a8fe2;color: #fff;padding: 5px 10px;border-top-left-radius: 10px;border-top-right-radius: 10px;text-align: center;font-size: 15px;">MOST PREFERRED</div>
                <v-card class="mx-auto pa-0 plan-card-border" :style="item.name == 'Skilled' ? 'border-top-left-radius: 0 !important;border-top-right-radius: 0 !important;' : ''">
                    <div class="pa-8">
                        <h1 class="font-weight-thin">{{ item.name }}</h1>
                        <h1 :style="'font-size: 3em;margin-bottom: 30px;' + (item.type == 'discounted' ? 'display: flex' : '' )">${{item.amount_usd}}<span v-if="item.type != 'discounted'" style="font-size: 15px;color: #555;">/Month</span><div v-if="item.type == 'discounted'" style="line-height: 11px;margin-top: 15px;margin-left: 8px;"><span style="font-size: 28px;color: #999;text-decoration: line-through;">{{ ((item.name == 'Rookie') ? '$49' : (item.name == 'Skilled') ? '$119' : (item.name == 'Advance') ? '$249' : (item.name == 'Expert') ? '$599' : '') }}</span><br><span style="font-size: 15px;color: #555;">/Month</span></div></h1>
                        
                        <p style="margin-bottom: 20px;" v-html="item.description"></p>
                    </div>
                    <div style="padding: 20px;text-align: center;background: #4a90e2;font-weight: 600;color: rgb(255, 255, 255);cursor:pointer" @click="purchase(item)">
                        Buy Now
                    </div>
                </v-card>
            </v-col>
        </v-row>
        <v-card-actions>
            <v-spacer></v-spacer>
            <span>For Custom Plans <a href="mailto:support@offersoptimize.com">Contact Us</a></span>
        </v-card-actions>
    </v-container>
</div>
</template>

<script>
import {
    mapActions,
} from "vuex";
import numeral from 'numeral'
export default {
    data: () => ({
        loading: true,
        plans: [],
        isCustomer: false,
        dialog: false,
        subscription: [],
        plan: [],
        dialog: false,
        loading: false,
        checkout: ''
    }),
    methods: {
        ...mapActions(["Plans", "buy_plans", "GetResponse", 'TrackEvents']),
        checkBilling() {
            this.dialog = true
        },
        async GetCustomer() {
            try {
                let url = '/v2/billing/customer'
                const data = (await this.GetResponse(url)).data
                if (data.success) {
                    this.isCustomer = true
                }
            } catch (err) {
                console.log(err)
            }
        },
        async Checkout(item) {
            this.loading = true
            this.TrackEvents({ event_name: 'planspage', checkout: true, item })
            try {
                let url = `/internal/v2/billing/checkout-url/${item.plan_id}`
                const data = (await this.GetResponse(url)).data
                if (data.success) {
                    window.open(data.data.checkout_url, "_top");
                    this.loading = false
                }
                this.loading = false
            } catch (err) {
                console.log(err)
                this.loading = false
            }
        },
        purchase(item){
            this.TrackEvents({ event_name: 'planspage', purchase: true, item })
            this.checkout = item
            this.dialog = true
        },
        async getSubcription() {
            try {
                let url = '/v2/billing/subscription'
                const data = (await this.GetResponse(url)).data
                if (data.success) {
                    this.subscription = data.data.subscription
                }
            } catch (err) {
                console.log(err)
            }
        },
        priceSort: function(arr) {
            return arr.slice().sort(function(a, b) {
                return a.amount_usd - b.amount_usd;
            });
        },
        async GetPlans() {
            try {
                let url = '/internal/v2/billing/plans'
                const data = (await this.GetResponse(url)).data
                if (data.success) {
                    this.plans = data.data.plans;
                    await this.getSubcription()
                    this.loading = false
                }
            } catch (err) {
                console.log(err)
            }
        },
        numeral(item){
            return numeral(item).format('0,0')
        }
    },
    async mounted() {
        await this.GetPlans()
        await this.GetCustomer()
    }
};
</script>

<style>
    .plan-card-border {
        box-shadow: none !important;
        border: 1px solid #cccccc !important;
    }
</style>
